import { useState, useEffect } from 'react'
import { can } from '../lib/features'
import { getRegisteredPhone, registerPhone, unregisterPhone } from '../services/whatsappService'
import type { PlanTier } from '../types'

export function useWhatsApp(planTier: PlanTier) {
  const [phone, setPhone] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!can('whatsapp_bot', planTier)) { setLoading(false); return }
    getRegisteredPhone().then(p => setPhone(p)).finally(() => setLoading(false))
  }, [planTier])

  const register = async (phoneE164: string) => {
    setError(null)
    try {
      await registerPhone(phoneE164)
      setPhone(phoneE164)
    } catch (e) {
      setError((e as Error).message)
      throw e
    }
  }

  const unregister = async () => {
    await unregisterPhone()
    setPhone(null)
  }

  return { phone, loading, error, register, unregister }
}
